<template>
  <section id="avatars">
    <div class="demo">
      <div class="row">
        <div class="col-6 col-sm-3 text-center">
          <h5>sm</h5>
          <img class="avatar avatar-sm" src="@/assets/gel/site-images/avatar.svg">
          <p>24x24</p>
        </div>
        <div class="col-6 col-sm-3 text-center">
          <h5>default</h5>
          <img class="avatar" src="@/assets/gel/site-images/avatar.svg">
          <p>36x36</p>
        </div>
        <div class="col-6 col-sm-3 text-center">
          <h5>md</h5>
          <img class="avatar avatar-md" src="@/assets/gel/site-images/avatar.svg">
          <p>48x48</p>
        </div>
        <div class="col-6 col-sm-3 text-center">
          <h5>lg</h5>
          <img class="avatar avatar-lg" src="@/assets/gel/site-images/avatar.svg">
          <p>80x80</p>
        </div>
      </div>
      <div class="row">
        <div class="col-6 col-sm-3 text-center">
          <span class="avatar avatar-sm" title="John Smith">JS</span>
          <p>24x24</p>
        </div>
        <div class="col-6 col-sm-3 text-center">
          <span class="avatar" title="John Smith">JS</span>
          <p>36x36</p>
        </div>
        <div class="col-6 col-sm-3 text-center">
          <span class="avatar avatar-md" title="John Smith">JS</span>
          <p>48x48</p>
        </div>
        <div class="col-6 col-sm-3 text-center">
          <span class="avatar avatar-lg" title="John Smith">JS</span>
          <p>80x80</p>
        </div>
      </div>
    </div>
    <section class="md" v-html="mdfile"></section>
  </section>
</template>

<script>
import mdfile from "@/docs/components/avatars.md";
export default {
  name: "avatars",
  beforeCreate: function() {
    this.$emit("update-title", this.$root.yamlData.components.avatars.name);
    this.$emit(
      "update-tagline",
      this.$root.yamlData.components.avatars.description
    );
  },
  data() {
    return {
      mdfile
    };
  }
};
</script>
